<template>
  <div class="runs-page">
    <div class="panel">
      <tableFilter ref="tableFilter"></tableFilter>

      <div class="tabs">
        <div :class="['tab', {selected: tabIndex === 2 }]" @click="tabIndex = 2">UNPACKAGED RESERVATIONS</div>
        <div :class="['tab', {selected: tabIndex === 1 }]" @click="tabIndex = 1">RUNS</div>
        <div class="upd-box">
          <div>Updated: <b>{{lastSync}}</b></div>
        </div>
        <div class="total">
          Total:
          <b v-if="tabIndex === 1">{{runs.list.length}}</b>
          <b v-else>{{runs.exclusive.list.length}}</b> |
          <!-- <span v-if="!!lastSync">Updated: <b>{{lastSync}}</b></span> -->
          <span class="filter-date" v-if="since !== 'Invalid date'">
            <span :class="['cal-trigger', {disabled: runs.exclusive.loading || runs.loading}]">
              <span @click.stop="toggleCal('since')">{{ since }}</span>
              <datepicker class="datepicker inline" :inline="true" v-show="showCal.since"
                :v-model="sinceCal" v-on:input="changeDate($event, 'since')" :format="calendarFormat"
                :disabled-picker="runs.exclusive.loading || runs.loading" :value="sinceCal"
                v-click-outside="closeDropdown"
              ></datepicker>
            </span> -
            <span :class="['cal-trigger', {disabled: runs.exclusive.loading || runs.loading}]">
              <span @click.stop="toggleCal('until')">{{ until }}</span>
              <datepicker class="datepicker inline" :inline="true" v-show="showCal.until"
                :v-model="untilCal" v-on:input="changeDate($event, 'until')" :format="calendarFormat"
                :disabled-picker="runs.exclusive.loading || runs.loading" :value="untilCal"
                v-click-outside="closeDropdown"
              ></datepicker>
            </span>
          </span>
        </div>
      </div>

      <div class="rsvp-panel">
        <div :class="['tab-content', {'show with-action': tabIndex === 1}]">
          <runs-table ref="runsTable"></runs-table>
          <div class="reservation-controls">
            <div class="row">
              <div class="columns end small-3 medium-3 medium-offset-3 padding-R">
                <a class="button cta small block" href="javascript:;" @click="moveToPool">MOVE TO POOL</a>
              </div>
              <div class="columns end small-3 padding-L">
                <a class="button cta small block error" @click="removeFromPool">REMOVE FROM POOL</a>
              </div>
            </div>
          </div>
        </div>
        <div :class="['tab-content', {show: tabIndex === 2 }]">
          <exclusive-table ref="exclusiveTable"></exclusive-table>
        </div>
      </div>
    </div>

    <div class="toggle-mobile" @click="showMapMobile = !showMapMobile">
      <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showMapMobile ? 'showMapBox' : '']">
      <div class="map">
        <runs-map></runs-map>
      </div>
      <div class="dropzone-container">
        <drop-zone></drop-zone>
      </div>
    </div>

    <routing-modal v-if="route === 'Runs'"></routing-modal>
    <dispatch-modal></dispatch-modal>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import TableFilter from './TableFilter'
import ExclusiveTable from './ExclusiveList'
import RunsTable from './RunsList'
import RunsMap from './Map'
import DropZone from './Dropzone'
import RoutingModal from '../Routing/RoutingModal'
import DispatchModal from '../Dispatch/DispatchModal'

export default {
  name: 'runs-page',
  components: { datepicker, TableFilter, ExclusiveTable, RunsTable, RunsMap, DropZone, RoutingModal, DispatchModal },
  data () {
    return {
      tabIndex: 2,
      showMapMobile: false,
      sinceCal: '',
      untilCal: '',
      showCal: {
        since: false,
        until: false
      }
    }
  },
  computed: {
    route () { return this.$route.name },
    runs () { return this.$store.state.runs },
    lastSync () { return this.$store.state.dispatch.lastSync },
    since () {
      let date = moment(this.runs.since, 'MM/DD/YYYY hh:mmA')
      return date.format('MMM DD hh:mmA')
    },
    until () {
      let date = moment(this.runs.until, 'MM/DD/YYYY hh:mmA')
      return date.format('MMM DD hh:mmA')
    },
  },
  methods: {
    total () {
      switch (this.tabIndex) {
        case 0: return this.$store.state.dispatch.totalItem
        case 1: return this.$store.state.routing.totalItem.pkg
        case 2: return this.$store.state.routing.totalItem.rsvp
        case 3: return this.$store.state.runs.list.length
      }
      return 0
    },
    moveToPool () {
      let self = this

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        })
        return
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...')
      self.startMoveToPool()
    },
    startMoveToPool () {
      let self = this
      
      self.$sdk.post('/runs/pool/move', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          })
          setTimeout (() => {
            self.$store.commit('dispatch/closeActionModal')
          }, 3000)
          return
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully move run to pool.'
        })
        setTimeout (() => {
          self.$store.commit('dispatch/closeActionModal')
        }, 2500)
      }, '2.0')
    },
    removeFromPool () {
      let self = this

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        })
        return
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...')
      self.startRemoveFromPool()
    },
    startRemoveFromPool () {
      let self = this
      
      self.$sdk.post('/runs/pool/remove', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          })
          setTimeout (() => {
            self.$store.commit('dispatch/closeActionModal')
          }, 3000)
          return
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully remove run from pool.'
        })
        setTimeout (() => {
          self.$store.commit('dispatch/closeActionModal')
        }, 2500)
      }, '2.0')
    },
    triggerFilter () {
      if (this.$refs.tableFilter) this.$refs.tableFilter.showFilter()
    },
    calendarFormat (date) { return moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY') },
    toggleCal (type) {
      let self = this
      if (self.runs.exclusive.loading || self.runs.loading) return
      self.showCal[type] = !self.showCal[type]
      if (type === 'since') self.showCal.until = false
      if (type === 'until') self.showCal.since = false
    },
    changeDate (x, type) {
      let self = this
      let tmp = {
        since: moment(self.runs.since, 'MM/DD/YYYY hh:mmA'),
        until: moment(self.runs.until, 'MM/DD/YYYY hh:mmA')
      }
      tmp[type] = moment(x)

      if (parseInt(tmp.since.format('D')) >= parseInt(tmp.until.format('D'))) {
        tmp[type === 'since' ? 'until' : 'since'] = tmp[type].clone()
      }

      tmp.since = `${tmp.since.format('MM/DD/YYYY')} 00:00AM`
      tmp.until = `${tmp.until.format('MM/DD/YYYY')} 11:59PM`
      self.$store.commit('runs/setRunsDetails', tmp)
      self.showCal[type] = false
      if (this.$refs.tableFilter) this.$refs.tableFilter.loadList()
    },
    closeDropdown (event) {
      if (this.showCal.since || this.showCal.until) {
        this.showCal.since = false
        this.showCal.until = false
      }
    }
  },
  mounted () {
    if (!this.runs.since) this.sinceCal = moment().format('MM/DD/YYYY')
    if (!this.runs.until) this.untilCal = moment().format('MM/DD/YYYY')
  }
}
</script>

<style lang="scss" scoped>
$panel-width: 995px;
.panel {
  z-index: 1;
  position: fixed;
  width: #{$panel-width};
  top: 0;
  left: 0;
  height: 100%;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
}

.tabs {
  position: relative;
  z-index: 2;
  width: $panel-width;
  display: flex;
  align-items: stretch;
  height: 54px;
  border-bottom: 1px solid rgba(0,0,0,0.3);
  border-top: 1px solid rgba(0,0,0,0.3);

  & .tab {
    padding: 0 10px;
    white-space: nowrap;
    display: flex;
    align-items: center;

    // display: inline-block;
    color: #0D79F2;
    position: relative;
    z-index: 2;
    font-weight: 700;
    font-size: 14px;
    // padding: 15px 8px;
    text-decoration: underline;
    cursor: pointer;
    transition: all 250ms;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;

    &.selected {
      background-color: #fff;
      border-left: 1px solid rgba(0,0,0,0.3);
      border-right: 1px solid rgba(0,0,0,0.3);
      text-decoration: none;
      cursor: default;
    }
  }
  .upd-box{
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 13px;
    gap: 5px;
    justify-content: center;
    color: transparent;
    cursor: default;

    div:hover{
      color: #777;
    }
  }
  .total{
    // position: absolute;
    // top: 0;
    // right: 0;
    z-index: 1;
    // line-height: 51px;
    padding: 0 20px;
    font-size: 14px;
    color: #333;
    font-weight: 600;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 5px;

    .filter-date{
      color: #555;
      display: inline-block;
      margin-left: 3px;
      font-size: 14px;
      position: relative;
      top: -1px;
      font-weight: 500;

      .cal-trigger{
        cursor: pointer;
        position: relative;

        &:hover{
          text-decoration: underline;
        }
        &.disabled{
          cursor:not-allowed;
          text-decoration: none;
        }
      }
    }
  }
}
.datepicker.inline{
  white-space: normal;
  position: absolute;
  top: 100%;
  right: 0;
}
.filter-date{
  letter-spacing: .4px;
}
.rsvp-panel{
  position: fixed;
  top: 101px;
  left: 0;
  overflow-y: auto;
  width: $panel-width;
  height: calc(100% - (50px + 51px));
  z-index: 1;
  margin-top: 2px;
}
.tab-content {
  display: none;
  height: 100%;
  overflow: auto;

  &.with-action{
    padding-bottom: 70px;
  }
  &.show {
    display: block;
  }

  &.with-control { height: calc(100% - 80px); }

  & .tab-control {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid rgba(0,0,0,0.3);
    padding: 20px 10px;
  }
}

.reservation-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  border-top: 1px solid rgba(0,0,0,0.2);
  border-right: 1px solid rgba(0,0,0,0.3);
  background-color: #fff;
}
.padding-R { padding-right: 5px; }
.padding-L { padding-left: 5px; }

.right-panel {
  z-index: 1;
  position: fixed;
  top: 0;
  left: #{$panel-width};
  width: calc(100% - #{$panel-width});
  height: 100%;
  & .map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55%;
    z-index: 2;
  }

  & .dropzone-container {
    position: absolute;
    top: 55%;
    left: 0;
    width: 100%;
    height: 45%;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.25);
  }
}

.toggle-mobile {
  display: none;
}

@media screen and (max-width: 430px) {
  .panel, .tabs, .rsvp-panel {
    width: 100% !important;
  }

  .right-panel {
    left: 0;
    width: 100%;
    z-index: 5;
    top: 100%;
    transition: all 0.3s ease;
    background-color: #fff;
    &.showMapBox {
      top: 0;
    }
    .map {
      height: 35%;
    }
    .dropzone-container {
      top: 35%;
      height: 65%;
    }
  }

  .tabs {
    z-index: 100;
    .tab { text-align: center; }
    .tab:nth-child(1) { grid-area: tab1; }
    .tab:nth-child(2) { grid-area: tab2; }
    .total { 
      grid-area: total; 
      width: 100%;
      text-align: right;
      background-color: #fff;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      border-top: 1px solid rgba(0, 0, 0, 0.3);
    }
    display: grid;
    grid-template-areas: 
    'tab1 tab2'
    'total total';
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 10;
    text-transform: uppercase;
    font-weight: 900;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/Runs/index.vue